/*
 * File: AllAppointments.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/12/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Shows and styles the list of all of the selected patient's appointments
 */
import React from "react";
import Api from "./PatientAppointmentApi";
import PatientIdStorage from "../store/PatientIdStore";
import UIProgress from "components/ui/UIProgress";
import UINotFound from "components/ui/UINotFound";
import AppointmentDetailLinks from "./AppointmentDetailLinks";
import AppointmentsToolbar from "./AppointmentsToolbar";
import NewAppointmentFabButton from "./NewAppointmentFabButton";
import FilterModel from "./store/FilterModel";
import AppointmentsTotals from "./AppointmentsTotals";
import { StoreContext } from "utils/useStore";
import User from "Store";
class AllAppointments extends React.Component {
  state = {
    loading: true,
    appointments: []
  };

  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.loaded = false;
    this.filterModel = FilterModel.create();
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let patientId = PatientIdStorage.getId();
    let filters = this.filterModel.createParameters();
    let appts = await Api.getAppointments(patientId, filters);
    this.setState({
      loading: false,
      appointments: appts
    });
  };

  render() {
    if (!this.loaded) {
      this.filterModel.getFromLocalStorage(this.context.getStore(User));
      this.loaded = true;
    }

    let { appointments, loading } = this.state;

    let apptListView;
    if (loading) {
      apptListView = <UIProgress />;
    } else if (appointments && appointments.length > 0) {
      apptListView = (
        <React.Fragment>
          <AppointmentsTotals apptList={appointments} />
          <AppointmentDetailLinks appointments={appointments} />
        </React.Fragment>
      );
    } else if (!loading && appointments.length === 0) {
      apptListView = <UINotFound message="No appointments were found" />;
    }

    return (
      <div>
        <AppointmentsToolbar
          title="Patient Appointments"
          filterModel={this.filterModel}
          fetchAppointments={this.fetchData}
        />
        {apptListView}
        <NewAppointmentFabButton {...this.props} />
      </div>
    );
  }
}

export default AllAppointments;
